<template>
<div class="exportSearch">
  <!--外部包裹容器-->
  <div class="topButton">
    <!--案例查找区-->
    <div class="find">
      <el-input v-model="findNumber" clearable placeholder="请输入要查找的案例编号"></el-input>
      <el-button type="primary" @click="getData">查找该案例</el-button>
    </div>

    <!--导出案例-->
    <div class="export">
      <el-button type="warning" @click="downloadData">导出选中案例</el-button>
    </div>
    <!--查看详情页面-->
    <rtas-all></rtas-all>
  </div>
  <!--表格展示区-->
  <div class="mainTable" ref="date">
    <!--表格组件-->
    <el-table ref="naisData" tooltip-effect="dark" border highlight-current-row :data="tableData.slice((pageInfo.currentPage-1)*pageInfo.pageSize,pageInfo.currentPage*pageInfo.pageSize)" :height="tableHeight" :max-height="tableHeight" :key="table"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" v-loading="loading"></el-table-column>
      <el-table-column v-for="(item,index) in tableTitle" :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width" align="center" :show-overflow-tooltip="item.show">
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="110" align="center">
        <template slot-scope="scope">
          <el-button size="mini" @click="getAllMsg(scope.$index,scope.row)"  type="primary">案例详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页器-->
    <el-pagination background layout="total,prev,sizes, pager, next,jumper" :current-page="pageInfo.currentPage" :page-size="pageInfo.pageSize" :total="tableData.length" @size-change="handleSizeChange" :page-sizes="[5, 10, 20, 30]"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</div>
</template>

<script>
import bus from './bus'
import rtasAll from './allMsg'

export default {
  name: "检索导出",
  components: {
    rtasAll
  },
  data() {
    return {
      /*加载动画*/
      loading: false,
      /*待查找的案例*/
      findNumber: '',
      /*多选时标记当前行的标记*/
      idKey: "caseNumber",
      /*通过key刷新表格*/
      table: 1,
      /*分页器的参数*/
      pageInfo: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0
      },
      /*当前页选中项*/
      multipleSelection: [],
      /*所有选中项*/
      multipleSelectionAll: [],
      /*表格的最大高度*/
      tableHeight: '',
      /*表格组件渲染数组*/
      tableTitle: [{
          label: "案例编号",
          width: "120",
          prop: "caseNumber",
          show: false
        },
        {
          label: "参与方总数",
          width: "120",
          prop: "participantsNum",
          show: false
        },
        {
          label: "事故形态",
          width: "160",
          prop: "accidentForm",
          show: true
        },
        {label:"场景类别",width:"130",prop:"totalType.typeOfScene",show:true},
        {label:"参与方类别",width:"130",prop:"typeOfParticipants",show:true},
        {
          label: "事故具体类型",
          width: "130",
          prop: "accidentType",
          show: true
        },
        {
          label: "障碍物类型",
          width: "130",
          prop: "obstacleType",
          show: true
        },
        {
          label: "天网及其他视频",
          width: "120",
          prop: "otherVideo",
          show: false
        },
        {
          label: "事故分类",
          width: "130",
          prop: "classificationOfAccidents",
          show: false
        },
        {
          label: "路段信息",
          width: "120",
          prop: "roadInformation",
          show: false
        },
        {
          label: "天气",
          width: "130",
          prop: "weather",
          show: false
        },
        {
          label: "事故发生时段",
          width: "130",
          prop: "periodOfAccident",
          show: false
        },
        {
          label: "参与方一类型",
          width: "130",
          prop: "typeOfParticipant0",
          show: false
        },
        {
          label: "参与方一行驶方式",
          width: "140",
          prop: "vehicleTravelled0",
          show: true
        },
        {
          label: "参与方一主要过错",
          width: "140",
          prop: "mainAccidentCause0",
          show: true
        },
        {
          label: "参与方一道路路口信号灯",
          width: "180",
          prop: "intersectionSignalLamp0",
          show: false
        },
        {
          label: "参与方二类型",
          width: "130",
          prop: "typeOfParticipant1",
          show: false
        },
        {
          label: "参与方二行驶方式",
          width: "140",
          prop: "vehicleTravelled1",
          show: true
        },
        {
          label: "参与方二主要过错",
          width: "140",
          prop: "mainAccidentCause1",
          show: true
        },
        {
          label: "参与方二道路路口信号灯",
          width: "180",
          prop: "intersectionSignalLamp1",
          show: false
        },
      ],
      /*表格数据*/
      tableData: [],
    }
  },
  methods: {
    /* 分页大小切换*/
    handleSizeChange(val) {
      this.changePageCoreRecordData();
      this.pageInfo.pageSize = val;
      this.queryData();
    },
    /*分页切换*/
    handleCurrentChange(val) {
      this.changePageCoreRecordData();
      this.pageInfo.currentPage = val;
      this.queryData();
    },
    /*表格选择*/
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /*分页勾选，再次调用*/
    queryData() {
      setTimeout(() => {
        this.setSelectRow();
      }, 20);
    },
    /*设置选中的方法*/
    setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let selectAllIds = [];
      let that = this;
      this.multipleSelectionAll.forEach(row => {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.naisData.clearSelection();
      for (let i = 0; i < this.tableData.length; i++) {
        if (selectAllIds.indexOf(this.tableData[i][idKey]) >= 0) {
          // 设置选中
          this.$refs.naisData.toggleRowSelection(this.tableData[i], true);
        }
      }
    },
    /*记忆选中核心方法*/
    changePageCoreRecordData() {
      // 标识当前行的唯一键的名称
      let idKey = this.idKey;
      let that = this;
      // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
      if (this.multipleSelectionAll.length <= 0) {
        this.multipleSelectionAll = this.multipleSelection;
        return;
      }
      // 总选择里面的key集合
      let selectAllIds = [];
      this.multipleSelectionAll.forEach(row => {
        selectAllIds.push(row[idKey]);
      });
      let selectIds = [];
      // 获取当前页选中的id
      this.multipleSelection.forEach(row => {
        selectIds.push(row[idKey]);
        // 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
        if (selectAllIds.indexOf(row[idKey]) < 0) {
          that.multipleSelectionAll.push(row);
        }
      });
      let noSelectIds = [];
      // 得到当前页没有选中的id
      this.tableData.forEach(row => {
        if (selectIds.indexOf(row[idKey]) < 0) {
          noSelectIds.push(row[idKey]);
        }
      });
      noSelectIds.forEach(id => {
        if (selectAllIds.indexOf(id) >= 0) {
          for (let i = 0; i < that.multipleSelectionAll.length; i++) {
            if (that.multipleSelectionAll[i][idKey] === id) {
              // 如果总选择中有未被选中的，那么就删除这条
              that.multipleSelectionAll.splice(i, 1);
              break;
            }
          }
        }
      });
    },
    /*获取高度*/
    getHeight() {
      /*定义两个高度，初始高度和现在高度*/
      let nowH;
      /*延迟获取当前高度*/
      this.$nextTick(() => {
        nowH = this.$refs.date.offsetHeight - 36;
      });
      let height = this.tableHeight;
      /*比对操作*/
      if (nowH !== height) {
        this.tableHeight = nowH;
        this.table++;
      }
    },
    /*查找函数*/
    getData() {
      this.loading = true;
      this.$http.get(
          '/export/search/' + this.findNumber
        )
        .then((res) => {
          let obj = {};
          for (let item in res) {
            /*再通过对key的遍历判断*/
            if (item === 'carList') {
              /*参与方为车*/
              let carList = res.carList;
              if (carList.length < 2) {
                /*一个车*/
                for (let key of Object.keys(carList[0])) {
                  obj[key + "0"] = carList[0][key];
                }
              } else {
                /*两个车*/
                for (let key of Object.keys(carList[0])) {
                  obj[key + "0"] = carList[0][key];
                }
                for (let key of Object.keys(carList[1])) {
                  obj[key + "1"] = carList[1][key];
                }
              }
            } else if (item === 'environment') {
              /*环境信息*/
              let environmentList = res.environment;
              for (let key of Object.keys(environmentList)) {
                if (key !== "caseNumber" && key !== "id") {
                  /*防止污染变量*/
                  obj[key] = environmentList[key];
                }
              }
            } else if (item === 'personList') {
              /*参与方二为行人*/
              if (res.personList.length > 0) {
                let personList = res.personList[0];
                for (let key of Object.keys(personList)) {
                  obj[key + "1"] = personList[key];
                }
              }
            } else if (item === 'twoWheelVehicleList') {
              /*参与方二为二轮车*/
              if (res.twoWheelVehicleList.length > 0) {
                let twoWheelVehicleList = res.twoWheelVehicleList[0];
                for (let key of Object.keys(twoWheelVehicleList)) {
                  obj[key + "1"] = twoWheelVehicleList[key];
                }
              }
            } else if (item === 'roadList') {
              /*道路信息*/
              let roadList = res.roadList;
              if (roadList.length < 2) {
                /*道路信息一*/
                for (let key of Object.keys(roadList[0])) {
                  obj[key + "0"] = roadList[0][key];
                }
              } else {
                /*道路信息两个*/
                for (let key of Object.keys(roadList[0])) {
                  obj[key + "0"] = roadList[0][key];
                }
                for (let key of Object.keys(roadList[1])) {
                  obj[key + "1"] = roadList[1][key];
                }
              }
            } else {
              for (let key of Object.keys(res)) {
                /*总体信息*/
                if (key === item) {
                  obj[key] = res[key];
                }
              }
            }
          }
          /*防止重复查找*/
          if (this.tableData.length > 0) {
            let time = 1;
            for (let i = 0; i < this.tableData.length; i++) {
              if (obj.caseNumber === this.tableData[i].caseNumber) {
                this.$message({
                  message: '该案例已经被查找',
                  type: 'error',
                  duration: 1000
                });
                time++;
                break;
              }
            }
            if (time !== 2) {
              this.tableData.push(obj);
            }
          } else {
            this.tableData.push(obj);
          }
          this.findNumber = '';
          this.$nextTick(
            this.loading = false,
          );
        })
        .catch((err) => {
          console.log(err);
          this.$nextTick(
            this.loading = false,
          );
        })
    },
    /*获取案例详情页面*/
    getAllMsg(index, row) {
      bus.$emit("visible");
      this.$http.get(
          '/total/total/' + row.id
        )
        .then((res) => {
          bus.$emit("allData", res);
        })
        .catch((err) => {
          console.log(err);
        })
    },
    /*下载选中的文件*/
    downloadData() {
      this.changePageCoreRecordData();
      this.queryData();
      let ids = [];
      for (let i = 0; i < this.multipleSelectionAll.length; i++) {
        ids[i] = this.multipleSelectionAll[i].id;
      }
      let formData = new FormData();
      for (let i = 0; i < ids.length; i++) {
        formData.append('ids', ids[i]);
      }
      if (localStorage.user !== '1' && ids.length > 1) {
        this.$message({
          message: "当前权限只能单个导出数据",
          type: 'error',
          center: true,
          duration: 2000
        })
      } else {
        this.$http.post(
            '/export/csv',
            formData, {
              responseType: 'blob'
            }, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          )
          .then((res) => {
            console.log(res);
            if (res.type === "application/json") {
              this.$message({
                message: "剩余可导出案例数不足",
                type: 'error',
                center: true,
                duration: 1500
              })
            } else {
              const content = res;
              const blob = new Blob([content]);
              const fileName = `.zip`;
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                if (ids.length > 1) {
                  elink.download = `data.zip`;
                } else {
                  elink.download = this.multipleSelectionAll[0].caseNumber + fileName;
                }
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          })
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = this.$refs.date.offsetHeight - 36;
    });
  },
  created() {
    /*在页面初始化时调用获取实时高度函数*/
    this.getHeight();
  }
}
</script>

<style scoped>
.exportSearch {
  height: calc(100% - 34px);
  width: 100%;
}

.topButton {
  height: 45px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  background-color: #E9EBEE;
}

.find {
  width: 45%;
  height: 100%;
  display: flex;
  align-items: center;
}

.find .el-button {
  margin-left: 10px;
}

.find .el-input {
  width: 50%;
}

.export {
  width: 45%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.mainTable {
  height: calc(100% - 45px);
  width: 100%;
}

.el-pagination {
  text-align: center;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/exportData/exportSearch.vue